/* eslint-disable no-bitwise */

export const hashStr = (val: string): number => {
  let hash = 0;
  let i;
  let chr;
  if (val.length === 0) return hash;

  for (i = 0; i < val.length; i += 1) {
    chr = val.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
};
